<template>
  <a-layout id="main-layout">

    <div>
      <slot/>
    </div>

    <div class="footer" v-if="showFooter" :style="{ textAlign: 'center' }">
      <span> CDTM ©2019  </span>
      <span> | </span>
      <span> {{ appVersion }}</span>
      <span> | </span>
      <a href="https://www.cdtm.de/contact/" target="_blank">Impressum</a>
      <span> | </span>
      <a href="https://www.cdtm.de/legal/" target="_blank">Data Privacy</a>
    </div>
  </a-layout>
</template>

<script>
export default {
  props: ['showFooter'],
  computed: {
    appVersion () {
      return `Version ${this.$store.getters.getApplicationVersion}`
    }
  }
}
</script>


<style>
#main-layout {
  background-color: #fcfcff;
  height: 100vh;
  max-height: 100vh;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
}
#main-layout .ant-layout-header {
 background-color: white;
 padding: 0;
}
#main-layout .ant-layout-content {
  min-height: calc(100vh - 69px);
}
#main-layout .footer{
  background-color: #fcfcff;
  padding: 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/layouts/MainLayout.vue